export default {
  "content": "<path d=\"M16 13H8v-2h8v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.956 2.005c.229.023.444.124.608.288l5.143 5.143a1 1 0 01.293.707v7.714a1 1 0 01-.293.707l-5.143 5.143a1 1 0 01-.707.293H8.143a1 1 0 01-.707-.293l-5.143-5.143A1 1 0 012 15.857V8.143a1 1 0 01.293-.707l5.143-5.143A1 1 0 018.143 2h7.714l.1.005zM4 8.557v6.886L8.557 20h6.886L20 15.443V8.557L15.443 4H8.557L4 8.557z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};